import { render, staticRenderFns } from "./AutomationNew.vue?vue&type=template&id=2187d629&scoped=true&"
import script from "./AutomationNew.vue?vue&type=script&lang=js&"
export * from "./AutomationNew.vue?vue&type=script&lang=js&"
import style0 from "./AutomationNew.vue?vue&type=style&index=0&id=2187d629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187d629",
  null
  
)

export default component.exports